import { Button } from '@winnin/winnin_ui.components.button'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Title } from '@winnin/winnin_ui.components.title'

import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './group-niches-form.i18n'
import type { TGroupNichesFormView } from './group-niches-form.types'
import './group-niches-form.styles.scss'
import { ConfirmNicheAction } from '../confirm-niche-action'

export const GroupNichesFormView = ({
  handleChange,
  handleSubmit,
  nicheList,
  nicheTitle,
  isSubmitButtonDisabled,
  isConfirmView,
  handleViewConfirmation,
  isMutationLoading,
  handleCancel,
}: TGroupNichesFormView) => {
  const t = useTranslate()

  if (isConfirmView) {
    return (
      <ConfirmNicheAction
        handleClose={handleCancel}
        handleConfirm={handleSubmit}
        isButtonDisabled={isMutationLoading}
      />
    )
  }

  return (
    <div className="GroupNichesForm">
      <Title tag="h2">
        <T keyName={translations.title.key}>{translations.title.defaultValue}</T>
      </Title>
      <div className="GroupNichesForm-nicheTitles">
        <T keyName={translations.groupText.key}>{translations.groupText.defaultValue}</T>
        {nicheList.map(niche => niche.name).join(', ')}
      </div>
      <InputWithLabel
        label={t(translations.inputTitle)}
        onChange={handleChange}
        placeholder={t(translations.inputTitle)}
        value={nicheTitle}
      />
      <div className="buttonsSection">
        <Button appearance="link" onClick={handleCancel}>
          <T keyName={TOLGEE_GLOBALS.cancel.key}>{TOLGEE_GLOBALS.cancel.defaultValue}</T>
        </Button>
        <Button onClick={handleViewConfirmation} disabled={isSubmitButtonDisabled}>
          <T keyName={TOLGEE_GLOBALS.confirm.key}>{TOLGEE_GLOBALS.confirm.defaultValue}</T>
        </Button>
      </div>
    </div>
  )
}
